<div class="w-100 h-100">
    <owl-carousel-o #owlElement [options]="customOptions">
        <ng-container *ngFor="let carouselModel of carouselItems">
            <ng-template
                carouselSlide
                *ngIf="
                    (carouselModel.promotion &&
                        carouselModel.promotion.nurseries &&
                        carouselModel.promotion.nurseries.length > 0 &&
                        carouselModel.promotion.nurseries[0].nursery &&
                        carouselModel.promotion.nurseries[0].nursery.promotionPhotosphereUuid) ||
                    carouselModel.nursery
                "
                [id]="carouselModel.promotion !== null ? carouselModel.promotion.uuid : carouselModel.nursery.uuid"
            >
                <div *ngIf="carouselModel.nursery" class="h-100 d-block item-container pt-2">
                    <span class="card-name" (click)="onNurseryClick(carouselModel.nursery.uuid)">{{
                        carouselModel.nursery.name
                    }}</span>
                    <div class="h-100 d-flex justify-content-center px-4 py-2">
                        <div
                            class="w-100 card-image"
                            (click)="onNurseryClick(carouselModel.nursery.uuid)"
                            [ngStyle]="{
                                'background-image': carouselModel.nursery.imageURL
                                    ? 'url(' + carouselModel.nursery.imageURL + ')'
                                    : 'url(/assets/img/img_placeholder.png)'
                            }"
                        >
                        </div>
                    </div>
                </div>
                <div *ngIf="carouselModel.promotion" class="h-100 d-block item-container pt-2 promo">
                    <span class="card-name" (click)="onPromotionClick(carouselModel.promotion)">{{
                        carouselModel.promotion.title
                    }}</span>
                    <div class="h-100 d-flex justify-content-center px-4 py-2">
                        <div
                            class="w-100 card-image"
                            (click)="onPromotionClick(carouselModel.promotion)"
                            [ngStyle]="{
                                'background-image': carouselModel.promotion.mediaURL
                                    ? 'url(' + carouselModel.promotion.mediaURL + ')'
                                    : 'url(/assets/img/promo_placeholder.png)'
                            }"
                        >
                        </div>
                    </div>
                </div>
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</div>
